// eslint-disable-next-line import/named
import {
  createRoute,
  lazyRouteComponent,
  redirect,
} from "@tanstack/react-router";

import PendingComponent from "../../components/PendingComponent";
import { isMeaningfulGigsRole } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export const askPunttStreamingTestRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/streaming-test",
  beforeLoad() {
    if (!isMeaningfulGigsRole()) {
      throw redirect({ to: ticketsRoute.to });
    }
  },
  // Lazy so this dev-only page is code-split out of the customer bundle.
  component: lazyRouteComponent(() => import("./streaming-test")),
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: false,
  pendingMs: 0,
  pendingMinMs: 500,
});
